import _ from 'lodash';

const MOST_POPULAR_SECTOR_NAMES = [
  'Business consulting',
  'Digital Marketing and Advertising',
  'Luxury Car Sales',
  'Software Development',
  'Software & IT Consulting',
  'Retail and Wholesale of Watches and Jewelry',
  'Real Estate Sales',
  'Wholesale of textiles, clothing and footwear',
];

const mapCountries = (response, isAlpha2 = false) =>
  _.chain(response)
    .values()
    .map((country) => ({
      label: country.attributes.name,
      value: country.attributes[isAlpha2 ? 'alpha2' : 'alpha3'],
    }))
    .sortBy((country) => country.label.toLowerCase())
    .value();

const mapSectors = (response) => {
  if (
    !response ||
    typeof response !== 'object' ||
    Object.keys(response).length === 0
  ) {
    return { categories: [], sectorsByCategory: {} };
  }

  const sectorsByCategory = _.chain(response)
    .values()
    .filter((sector) => {
      if (!sector || !sector.attributes) {
        return false;
      }

      return true;
    })
    .groupBy((sector) => sector.attributes.industrySector)
    .mapValues((sectors) =>
      sectors.map((sector) => ({
        label: sector.attributes.division,
        value: sector.id,
      }))
    )
    .value();

  const categories = Object.keys(sectorsByCategory).map((category) => ({
    label: category,
    value: category,
  }));

  return { categories, sectorsByCategory };
};

const mapSectorsForGroupedDropdown = (response) => {
  if (
    !response ||
    typeof response !== 'object' ||
    Object.keys(response).length === 0
  ) {
    return [];
  }

  const allSectors = _.chain(response)
    .values()
    .filter((sector) => {
      if (!sector || !sector.attributes) {
        return false;
      }
      return sector.attributes.isActive;
    })
    .value();

  const sectorsByCategory = _.chain(allSectors)
    .groupBy((sector) => sector.attributes.industrySector)
    .mapValues((sectors) =>
      sectors.map((sector) => ({
        label: sector.attributes.division,
        value: sector.id,
      }))
    )
    .value();

  const mostPopularItems = MOST_POPULAR_SECTOR_NAMES.map((divisionName) => {
    const sector = allSectors.find(
      (s) => s.attributes.division === divisionName && s.attributes.isActive
    );
    return sector
      ? {
          label: sector.attributes.division,
          value: sector.id,
        }
      : null;
  }).filter(Boolean);

  const mostPopularGroup = {
    value: 'Most Popular',
    groupLabel: 'Most Popular',
    groupItems: mostPopularItems,
  };

  const otherGroups = Object.keys(sectorsByCategory).map((category) => ({
    value: category,
    groupLabel: category,
    groupItems: sectorsByCategory[category],
  }));

  return [mostPopularGroup, ...otherGroups];
};

export { mapCountries, mapSectors, mapSectorsForGroupedDropdown };
